/* Speed Junkies - one click "Join VIP" .
   Adds the real VIP variant plus its monthly selling plan to the cart with
   AJAX and sends the customer straight to Shopify checkout. Nothing about the
   product, the subscription contract or the entry system is faked or bypassed:
   this is the normal /cart/add.js -> /checkout path, so the Subscriptions app
   and the SpeedjunkiesHQ Manager entry hooks behave exactly as they do from
   the full product form. If anything fails we fall back to the full purchase
   card so the customer always has a working way to buy. */
(function () {
  'use strict';
  if (window.__sjVipQuickBuy) return;
  window.__sjVipQuickBuy = true;

  var CHECKOUT = '/checkout';

  function label(btn, text) {
    var el = btn.querySelector('[data-sj-label]');
    if (el) el.textContent = text; else btn.textContent = text;
  }

  function busy(btn, on) {
    btn.disabled = !!on;
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
    if (on) btn.setAttribute('data-busy', '1'); else btn.removeAttribute('data-busy');
    var spin = btn.querySelector('[data-sj-spin]');
    if (spin) spin.hidden = !on;
    label(btn, on
      ? (btn.getAttribute('data-busy-label') || 'Adding...')
      : (btn.getAttribute('data-idle-label') || 'Join VIP'));
  }

  function fallback(btn, message) {
    var target = btn.getAttribute('data-fallback') || '#sj-vip-purchase';
    var node = null;
    try { node = document.querySelector(target); } catch (e) { node = null; }
    if (message) {
      var box = document.querySelector('[data-sj-vip-error]');
      if (box) { box.textContent = message; box.hidden = false; }
    }
    if (node && node.scrollIntoView) node.scrollIntoView({ behavior: 'smooth', block: 'start' });
    else window.location.href = '/products/vip-membership';
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-sj-vip-quickbuy]') : null;
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('data-busy') === '1') return;

    var variant = parseInt(btn.getAttribute('data-variant-id') || '', 10);
    var plan = parseInt(btn.getAttribute('data-selling-plan') || '', 10);

    if (!variant) { fallback(btn, btn.getAttribute('data-error-generic') || ''); return; }

    var item = { id: variant, quantity: 1 };
    if (plan) item.selling_plan = plan;

    busy(btn, true);

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (body) {
          if (!r.ok) {
            var msg = body.description || body.message || ('Add to cart failed (' + r.status + ')');
            throw new Error(msg);
          }
          return body;
        });
      })
      .then(function () { window.location.href = CHECKOUT; })
      .catch(function (err) {
        busy(btn, false);
        if (window.console) console.warn('[sj-vip-quickbuy]', err && err.message);
        fallback(btn, btn.getAttribute('data-error-generic') || 'We could not start your checkout. Please use the membership card below.');
      });
  });
})();
